import {
	EventCollectorService,
	EventVerb,
	EventType,
} from '@altvia/js-event-collector';

const eventCollectorClient = new EventCollectorService({
	gatewayUrl: `${process.env.REACT_APP_API_URL}/events`,
	sourceService: 'launchpad',
	debug: false,
});

export { eventCollectorClient, EventVerb, EventType };
